export const LINK_DIALOG_OPEN_EVENT = 'editor:open-link-dialog';
